import { render } from "./editReserveComponent.vue?vue&type=template&id=332d31b1&scoped=true"
import script from "./editReserveComponent.vue?vue&type=script&lang=js"
export * from "./editReserveComponent.vue?vue&type=script&lang=js"

import "./editReserveComponent.vue?vue&type=style&index=0&id=332d31b1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332d31b1"]])

export default __exports__